// Countdown.tsx
import React, { useEffect, useState } from 'react';

interface CountdownProps {
    totalTime: number; // Tempo totale in secondi
    setTimeExpired: (expired: boolean) => void;
}

const Countdown: React.FC<CountdownProps> = ({ totalTime, setTimeExpired }) => {
    const [timeLeft, setTimeLeft] = useState(totalTime);

    useEffect(() => {
        if (timeLeft > 0) {
            setTimeout(() =>
                setTimeLeft(timeLeft - 1000)
            , 1000);
            // return () => clearTimeout(timer);

            // setInterval(() => {
            //     setTimeLeft(timeLeft - 1000)
            //     console.log("timeLeft", timeLeft)
            // }, 1000)

            // console.log("timeLeft", timeLeft)
            // setTimeLeft(timeLeft - 1000)
        }
        else {
            setTimeout(() => setTimeExpired(true), 1000);
        }
    }, [timeLeft]);

    let minutes = Math.floor(timeLeft / 60000);
    let seconds = Math.floor((timeLeft % 60000) / 1000);

    return (
        <div style={{ position: 'fixed', bottom: '20px', right: '20px', background: '#fdc54d', color: 'black', padding: '10px 15px', borderRadius: 20, width: 100, display: 'flex', justifyContent: 'space-between', alignItems: 'center', fontSize: 16 }} id='timeout'>
            <svg xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 54 54" version="1.1" x="0px" y="0px" height={20} width={20}>
  <path d="M3.13846154,29.6307692 C3.13846154,16.9846154 12.9230769,6.6 25.3846154,5.63076923 L25.3846154,4.01538462 L20.9076923,4.01538462 C19.8461538,4.01538462 19.0153846,3.18461538 19.0153846,2.12307692 C19.0153846,1.06153846 19.8461538,0.230769231 20.9076923,0.230769231 L33.3692308,0.230769231 C34.4307692,0.230769231 35.2615385,1.06153846 35.2615385,2.12307692 C35.2615385,3.18461538 34.4307692,4.01538462 33.3692308,4.01538462 L29.1692308,4.01538462 L29.1692308,5.63076923 C33.7846154,6 37.9846154,7.61538462 41.4923077,10.2 L43.5692308,8.12307692 L42.6923077,7.24615385 C41.9538462,6.50769231 41.9538462,5.30769231 42.6923077,4.56923077 C43.4307692,3.83076923 44.6307692,3.83076923 45.3692308,4.56923077 L49.7538462,8.95384615 C50.4923077,9.69230769 50.4923077,10.8923077 49.7538462,11.6307692 C49.3846154,12 48.9230769,12.1846154 48.4153846,12.1846154 C47.9076923,12.1846154 47.4461538,12 47.0769231,11.6307692 L46.2,10.7538462 L44.3076923,12.6461538 C48.6461538,16.9846154 51.3230769,23.0307692 51.3230769,29.6307692 C51.3230769,42.9230769 40.5230769,53.7230769 27.2307692,53.7230769 C13.9384615,53.7230769 3.13846154,42.9230769 3.13846154,29.6307692 Z M27.2307692,9.32307692 C16.0153846,9.32307692 6.87692308,18.4153846 6.87692308,29.6769231 C6.87692308,40.8923077 16.0153846,50.0307692 27.2307692,50.0307692 C38.4461538,50.0307692 47.5846154,40.8923077 47.5846154,29.6769231 C47.5846154,18.4615385 38.4461538,9.32307692 27.2307692,9.32307692 Z M27.2307692,31.2 C26.1692308,31.2 25.3384615,30.3692308 25.3384615,29.3538462 L25.3384615,17.6769231 C25.3384615,16.6153846 26.1692308,15.7846154 27.2307692,15.7846154 C28.2923077,15.7846154 29.1230769,16.6153846 29.1230769,17.6769231 L29.1230769,27.4153846 L35.3076923,27.4153846 C36.3692308,27.4153846 37.2,28.2461538 37.2,29.3076923 C37.2,30.3692308 36.3692308,31.2 35.3076923,31.2 L27.2307692,31.2 Z" />
</svg>
            {minutes < 10 ? `0${minutes}` : minutes}:{seconds < 10 ? `0${seconds}` : seconds}
        </div>
    );
};

export default Countdown;